var map = {
	"./Pancreas_RC_sagittal.png": 5241,
	"./Pancreas_RC_sagittal_HBT.png": 4974,
	"./Pancreas_RC_transverse.png": 6875,
	"./Pancreas_RC_transverse_CP.png": 3153,
	"./ages/adult-islet.png": 1605,
	"./ages/childhood-islet.png": 4781,
	"./ages/infancy-islet.png": 6893,
	"./ages/neonatal-islet.png": 8525,
	"./ages/timeline-adolescence.png": 6199,
	"./ages/timeline-adult.png": 7379,
	"./ages/timeline-childhood.png": 2711,
	"./ages/timeline-infancy.png": 7275,
	"./ages/timeline-neonatal.png": 627,
	"./contributors/adel-eskaros.png": 9432,
	"./contributors/al-powers.jpg": 1853,
	"./contributors/chris-wright.jpg": 3198,
	"./contributors/diane-saunders.jpg": 6856,
	"./contributors/jack-walker.jpg": 9223,
	"./contributors/jordan-wright.jpg": 823,
	"./contributors/klaus-kaestner.jpg": 4939,
	"./contributors/marcela-brissova.jpg": 644,
	"./contributors/mark-atkinson.jpg": 5742,
	"./contributors/nathaniel-hart.jpg": 5765,
	"./contributors/noel-morgan.jpg": 7572,
	"./contributors/pan-fong.jpg": 8953,
	"./contributors/rita-bottino.jpg": 9613,
	"./contributors/sarah-richardson.jpg": 9430,
	"./contributors/seung-kim.jpg": 9965,
	"./credits/al.jpg": 3518,
	"./credits/alec.jpg": 2966,
	"./credits/amber.jpg": 2244,
	"./credits/conrad.jpg": 6000,
	"./credits/default.png": 8954,
	"./credits/diane.jpg": 4756,
	"./credits/jimmy.jpg": 9987,
	"./credits/jp.jpg": 4543,
	"./credits/marcela.jpg": 6320,
	"./credits/marcelo.jpg": 2238,
	"./credits/matt.jpg": 8699,
	"./credits/sam.jpg": 2320,
	"./credits/shristi.jpg": 1297,
	"./credits/tom.jpg": 2346,
	"./datasets/1120/exo-path-title-image.png": 3710,
	"./datasets/1120/exocrine-pancreas-pathophysiology.jpg": 2060,
	"./datasets/1120/exocrine-path-altImg.png": 6363,
	"./datasets/1129/1129-HANDEL-I_schematic.png": 3266,
	"./datasets/1129/pediatric-immune-tissue-development-handel-i.jpg": 4386,
	"./datasets/1138/omics-collection-banner.jpg": 6813,
	"./datasets/1408/1408_IMC_figure.jpg": 6332,
	"./datasets/1408/79-plex-imc-type-1-diabetes-isletimmune-interface.jpg": 3228,
	"./datasets/410/CFRD_JCI_header.jpg": 7134,
	"./datasets/410/CFRD_processing_schematic.jpg": 1315,
	"./datasets/410/cystic-fibrosis-related-diabetes-cfrd.jpg": 831,
	"./datasets/459/HANDELP_diagram.jpg": 4199,
	"./datasets/459/neonatal-development--early-life-pancreas-handel-p.jpg": 6735,
	"./datasets/508/HPAP_article.jpg": 752,
	"./datasets/508/HPAP_schematic.jpg": 7961,
	"./datasets/508/human-pancreas-analysis-program-hpap.jpg": 9817,
	"./datasets/525/nPOD_article.png": 2813,
	"./datasets/525/npod-case-6362.jpg": 6017,
	"./datasets/525/npod.jpg": 6826,
	"./datasets/531/HANDEL-P_cohort_img.jpg": 6723,
	"./datasets/531/HANDELP_diagram.jpg": 8732,
	"./datasets/531/neonatal-development--early-life-pancreas-handel-p.jpg": 1494,
	"./datasets/703/exocrine-pancreas-in-type-1-diabetes.jpg": 3603,
	"./datasets/703/exocrine_image.png": 8948,
	"./datasets/853/integrated-islet-distribution-program-iidp-banner.webp": 2142,
	"./datasets/853/integrated-islet-distribution-program-iidp-dataImg.jpg": 2565,
	"./datasets/853/integrated-islet-distribution-program-iidp.jpg": 1599,
	"./datasets/853/load1.jpg": 2890,
	"./datasets/853/load1.png": 3630,
	"./datasets/904/early-stage-type-2-diabetes.jpg": 8884,
	"./datasets/904/t2d-altImg.png": 1693,
	"./datasets/904/t2d-title-image.png": 2969,
	"./datasets/960/eadb-altImg.png": 7075,
	"./datasets/960/eadb-title-image.png": 7715,
	"./datasets/960/exeter-archival-diabetes-biobank-eadb.jpg": 3934,
	"./headers/about-header.jpg": 6294,
	"./headers/collaborators-header-old.jpg": 9010,
	"./headers/contributors-header.jpg": 2497,
	"./headers/data-usage-header.png": 8937,
	"./headers/dataset-list-header-old.jpg": 9724,
	"./headers/dataset-list-header.jpg": 5076,
	"./headers/nomenclature-header.jpg": 7396,
	"./headers/releases-header.jpg": 2737,
	"./headers/resources-header-OLD.jpg": 730,
	"./headers/resources-header.jpg": 1054,
	"./logos/79-plex-imc-type-1-diabetes-isletimmune-interface-banner.jpg": 1598,
	"./logos/79-plex-imc-type-1-diabetes-isletimmune-interface-banner.webp": 2160,
	"./logos/amyloid-formation-in-type-2-diabetes-t2d-banner.jpg": 1848,
	"./logos/amyloid-formation-in-type-2-diabetes-t2d-banner.webp": 220,
	"./logos/collection-card-all-banner.jpg": 6487,
	"./logos/collection-card-all-banner.webp": 4991,
	"./logos/cystic-fibrosis-related-diabetes-cfrd-banner.jpg": 3729,
	"./logos/cystic-fibrosis-related-diabetes-cfrd-banner.webp": 2741,
	"./logos/early-stage-type-2-diabetes-banner.jpeg": 1783,
	"./logos/early-stage-type-2-diabetes-banner.webp": 1768,
	"./logos/exeter-archival-diabetes-biobank-eadb-banner.jpg": 3226,
	"./logos/exeter-archival-diabetes-biobank-eadb-banner.webp": 708,
	"./logos/exeter-archival-diabetes-biobank-eadb.jpg": 4293,
	"./logos/exeter-archival-diabetes-biobank-eadb.webp": 9655,
	"./logos/exocrine-pancreas-in-type-1-diabetes-banner.jpg": 6652,
	"./logos/exocrine-pancreas-in-type-1-diabetes-banner.webp": 620,
	"./logos/exocrine-pancreas-pathophysiology-banner.png": 87,
	"./logos/exocrine-pancreas-pathophysiology-banner.webp": 7347,
	"./logos/handel-p-banner-old.png": 9785,
	"./logos/handel-p-banner-old.webp": 3663,
	"./logos/handel-p-black-full.png": 9294,
	"./logos/handel-p-black.png": 2622,
	"./logos/handel-p-white-small.png": 4546,
	"./logos/helmsley-logo.jpg": 562,
	"./logos/human-pancreas-analysis-program-hpap-banner.jpg": 8475,
	"./logos/human-pancreas-analysis-program-hpap-banner.webp": 5673,
	"./logos/human-pancreas-analysis-program-hpap.png": 6530,
	"./logos/human-pancreas-analysis-program-hpap.webp": 868,
	"./logos/human-pancreas-development-banner.jpg": 3733,
	"./logos/human-pancreas-development-banner.webp": 4527,
	"./logos/image-formats-suite-banner.jpg": 7025,
	"./logos/image-formats-suite-banner.webp": 4373,
	"./logos/images-with-metadata-banner.jpg": 8273,
	"./logos/integrated-islet-distribution-program-iidp-banner.png": 1360,
	"./logos/integrated-islet-distribution-program-iidp-banner.webp": 5460,
	"./logos/load1.jpg": 3854,
	"./logos/load1.webp": 1821,
	"./logos/neonatal-development--early-life-pancreas-handel-p-banner.jpg": 9874,
	"./logos/neonatal-development--early-life-pancreas-handel-p-banner.webp": 9202,
	"./logos/neonatal-development--early-life-pancreas-handel-p.png": 8957,
	"./logos/neonatal-development--early-life-pancreas-handel-p.webp": 5369,
	"./logos/npod-case-6362-banner.jpg": 4348,
	"./logos/npod-case-6362-banner.webp": 9476,
	"./logos/pediatric-immune-tissue-development-handel-i-banner.jpg": 1564,
	"./logos/pediatric-immune-tissue-development-handel-i-banner.webp": 7496,
	"./logos/single-cell-omics-datasets-banner.jpg": 1091,
	"./logos/single-cell-omics-datasets-banner.webp": 3086,
	"./page_imgs/Pancreatlas-Patterns-graphical-abstract.png": 2616,
	"./page_imgs/Pancreatlas-Patterns.png": 9503,
	"./page_imgs/banner-bg3-fade.jpg": 4899,
	"./page_imgs/citation_image_view.jpg": 6736,
	"./page_imgs/citation_pathviewer.jpg": 6010,
	"./page_imgs/map-collaborations.png": 502,
	"./page_imgs/pancreas-islet-cells.png": 5088,
	"./page_imgs/pancreas-islet-cells.webp": 5550,
	"./page_imgs/pancreatlas-logo.png": 8939,
	"./resources_logos/CMD-KP.png": 5809,
	"./resources_logos/DGA.png": 9549,
	"./resources_logos/HPA.png": 9528,
	"./resources_logos/ada-isletcore.png": 7479,
	"./resources_logos/amp-t2d.png": 5482,
	"./resources_logos/bioimage-archive.jpg": 6709,
	"./resources_logos/cpdpc.png": 7245,
	"./resources_logos/dknet.png": 4193,
	"./resources_logos/espace.png": 3012,
	"./resources_logos/handel-p.jpg": 8446,
	"./resources_logos/hipp.png": 4908,
	"./resources_logos/hirn-rb.png": 3835,
	"./resources_logos/hirn.png": 3816,
	"./resources_logos/hpap.png": 9546,
	"./resources_logos/hubmap.jpg": 7056,
	"./resources_logos/iiam.jpg": 3045,
	"./resources_logos/iidp.png": 8647,
	"./resources_logos/jdrf.png": 6095,
	"./resources_logos/ndri.jpg": 1880,
	"./resources_logos/npf.png": 1313,
	"./resources_logos/npod.jpg": 4658,
	"./resources_logos/quod.png": 9854,
	"./resources_logos/sugarscience.png": 7957,
	"./resources_logos/t1d-exchange.png": 4110,
	"./resources_logos/tiger.png": 5620,
	"./resources_logos/trialnet.jpg": 8548,
	"./section_plane_images/Body-Saggital.png": 3741,
	"./section_plane_images/HBT-Sagittal.png": 6424,
	"./section_plane_images/Head-Sagittal.png": 3742,
	"./section_plane_images/Isolated-islets.png": 4710,
	"./section_plane_images/NonPLN.png": 4393,
	"./section_plane_images/PLN.png": 64,
	"./section_plane_images/Spleen.png": 3181,
	"./section_plane_images/Tail-Saggital.png": 3771,
	"./section_plane_images/Thymus.png": 458,
	"./section_plane_images/Transverse.png": 6485,
	"./section_plane_images/Unknown-Default.png": 5660,
	"./sponsor/IIAM.png": 1357,
	"./sponsor/IIDP.png": 1695,
	"./sponsor/NDRI.jpg": 1792,
	"./sponsor/NIDDK.png": 4239,
	"./sponsor/VA.png": 9694,
	"./sponsor/VUMC.png": 6442,
	"./sponsor/helmsley.jpg": 498,
	"./sponsor/helmsley.webp": 4280,
	"./sponsor/hirn.jpg": 8980,
	"./sponsor/hirn.webp": 3790,
	"./sponsor/iiam.webp": 801,
	"./sponsor/iidp.webp": 947,
	"./sponsor/ndri.webp": 6846,
	"./sponsor/vumc.webp": 6112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;